import { Controller } from "react-hook-form";
import { lang } from "../../Utils/lang";
import { TextField } from "@mui/material";

export default function CompanyData(props: any) {
  const { control } = props;

  return (
    <>
      <Controller
        name="address"
        defaultValue={undefined}
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <TextField
            onChange={onChange}
            fullWidth
            style={{
              marginBottom: 15,
            }}
            value={value}
            error={!!error}
            helperText={error?.message}
            id="address"
            label={lang.address}
            size="small"
            variant="outlined"
          />
        )}
      />
      <Controller
        name="cif"
        defaultValue={undefined}
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <TextField
            onChange={onChange}
            fullWidth
            style={{
              marginBottom: 15,
            }}
            value={value}
            error={!!error}
            helperText={error?.message}
            id="cif"
            label={lang.CIF}
            size="small"
            variant="outlined"
          />
        )}
      />
      <Controller
        name="iban"
        defaultValue={undefined}
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <TextField
            onChange={onChange}
            fullWidth
            style={{
              marginBottom: 15,
            }}
            value={value}
            error={!!error}
            helperText={error?.message}
            id="iban"
            label={lang.IBAN}
            size="small"
            variant="outlined"
          />
        )}
      />
      <Controller
        name="bank"
        defaultValue={undefined}
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <TextField
            onChange={onChange}
            fullWidth
            style={{
              marginBottom: 15,
            }}
            value={value}
            error={!!error}
            helperText={error?.message}
            id="bank"
            label={lang.bank}
            size="small"
            variant="outlined"
          />
        )}
      />
      <Controller
        name="nrRegCom"
        defaultValue={undefined}
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <TextField
            onChange={onChange}
            fullWidth
            style={{
              marginBottom: 15,
            }}
            value={value}
            error={!!error}
            helperText={error?.message}
            id="nrRegCom"
            label={lang.nrRegCom}
            size="small"
            variant="outlined"
          />
        )}
      />
    </>
  );
}
